import { RefObject, useCallback } from 'react';
import { List } from 'react-virtualized';

export const useRecomputeRowHeights = (listRef: RefObject<List>) => {
  // react-virtualized のリストの行の高さを再計算してレンダリングし直す
  const recomputeRowHeights = useCallback<() => void>(() => {
    if (listRef && listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [listRef]);

  return { recomputeRowHeights };
};
